import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <section className="not-found">
      <h1>404 — Page not found</h1>
      <p>
        The page you requested does not exist. Return to the{' '}
        <Link to="/">dashboard</Link>.
      </p>
    </section>
  );
}
